import _ from 'lodash';

const journeyRecommendationAsset = (
  analytics, 
  journeyConfigurations, 
  nextJourneyAsset, 
  setNextJourneyAsset,
  hasConditionRun,
  setHasConditionRun, 
  setJourneyTrigger,
  setShowRecommendSlide,
  setIsJourneyEnd
) => {

  if (!analytics || !journeyConfigurations) return;
  const { filters, defaultStep, conditionalStep, journeyExecution, asset, id } = journeyConfigurations;
  const { duration, percentageRead } = analytics;
  const { property, value } = Array.isArray(filters) && filters[0] ? filters[0] : {};
  const analyticsValue = property?.type === 'PERCENTAGE' ? percentageRead : duration;
  const filterValue = Array.isArray(value) && value[0] && parseFloat(value[0]);
  const isJourneyEnd = journeyExecution?.status == "COMPLETED";

  setJourneyTrigger(true);

  if (isJourneyEnd) {
    setShowRecommendSlide(false);
    setIsJourneyEnd(true);
    return;
  }
  if (asset != null && nextJourneyAsset?.step?.id != id) {
    setShowRecommendSlide(false);

    setTimeout(() => {
      setNextJourneyAsset(state => {
        return {
          ...state,
          step: { id, asset}, 
          journeyExecution, 
        }
      })
      setShowRecommendSlide(true);
    }, 500);
    
    return { id, asset };
  }

  if (asset == null && conditionalStep !=null && analyticsValue >= filterValue && (nextJourneyAsset?.step?.id != conditionalStep?.id || nextJourneyAsset?.step == null)) {
    if (!hasConditionRun) {
      setShowRecommendSlide(false);
      if(conditionalStep?.asset != null) {
        setHasConditionRun(true);
        setTimeout(() => {
            setNextJourneyAsset(state => {
              return {
                ...state,
                step: conditionalStep, 
                journeyExecution, 
              }
            });
            setShowRecommendSlide(true);
        }, 500);

        return conditionalStep;
      } else {
        setNextJourneyAsset(state => {
          return {
            ...state,
            step: conditionalStep, 
            journeyExecution, 
          }
        });
        setShowRecommendSlide(false);
        return conditionalStep;
      }
    }
  }

  if (asset == null && defaultStep != null && nextJourneyAsset?.step?.id != defaultStep?.id) {
    if (defaultStep?.asset != null) {
        setNextJourneyAsset(state => {
          return {
            ...state,
            step: defaultStep, 
            journeyExecution,
          }
        });
    
        setShowRecommendSlide(true);

      return defaultStep;
    } else {
      setNextJourneyAsset(state => {
        return {
          ...state,
          step: defaultStep, 
          journeyExecution, 
        }
      });
      setShowRecommendSlide(false);
      return defaultStep;
    }
    
  }
  return;
};

export default journeyRecommendationAsset;